import { render, staticRenderFns } from "./CreditConfig.vue?vue&type=template&id=43f11b78&scoped=true"
import script from "./CreditConfig.vue?vue&type=script&lang=js"
export * from "./CreditConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f11b78",
  null
  
)

export default component.exports